// import React from "react";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Autoplay, Navigation } from "swiper/modules";

// import "swiper/css";
// import "swiper/css/navigation";

// const testimonials = [
//   {
//     name: "Mr. Rohit Patil",
//     text: "Shivai Travels provided excellent Pune to Mumbai cab service. The driver was polite and the ride was very smooth and comfortable.",
//   },

//   {
//     name: "Miss. Aishwarya Deshmukh",
//     text: "We booked an Innova Crysta for a family trip to Lonavala. Great service, clean car, and on-time pickup. Highly recommended!",
//   },

//   {
//     name: "Mr. Sagar Jadhav",
//     text: "Best outstation cab service from Pune. Very professional drivers and hassle-free booking experience with Shivai Travels.",
//   },

//   {
//     name: "Miss. Pooja Kulkarni",
//     text: "Tempo Traveller was very spacious and perfect for our group tour to Mahabaleshwar. Excellent service and affordable pricing.",
//   },

//   {
//     name: "Mr. Nikhil Shinde",
//     text: "Used Shivai Travels for airport pickup and drop. Always on time, clean cars, and very professional service every time.",
//   },
// ];

// const TestimonialSectionabout = () => {
//   return (
//     <div className="section-full p-t150 site-bg-white twm-testimonial-section-wrap wow fadeInDown">
//       <div className="container">

//         {/* TITLE */}
//         <div className="row">
//           <div className="col-lg-6 col-md-12">
//             <div className="section-head left">
//               <div className="twm-sm-title left">Testimonial</div>
//               <h2 className="twm-large-title site-text-dark">
//                 What Our Customers Say
//               </h2>
//             </div>
//           </div>
//         </div>

//         {/* SLIDER */}
//         <div className="section-content">
//           <Swiper
//             modules={[Autoplay, Navigation]}
//             spaceBetween={30}
//             slidesPerView={3}
//             loop={true}
//             autoplay={{
//               delay: 2500,
//               disableOnInteraction: false,
//             }}
//             navigation={true}
//             breakpoints={{
//               0: { slidesPerView: 1 },
//               768: { slidesPerView: 2 },
//               1200: { slidesPerView: 3 },
//             }}
//           >
//             {testimonials.map((item, index) => (
//               <SwiperSlide key={index}>
//                 <div className="twm-testimonial2">

//                   {/* HEADER */}
//                   <div className="twm-testimonial-head">
//                     <div className="media-pic">
//                       <img src={item.img} alt={item.name} />
//                     </div>
//                     <div className="twm-author-detail">
//                       <h3 className="twm-title">{item.name}</h3>
//                       <div className="twm-position">Customer</div>
//                     </div>
//                   </div>

//                   {/* CONTENT */}
//                   <div className="twm-testimonial-detail">
//                     <p>{item.text}</p>

//                     <div className="twm-rating-wrap">
//                       {[...Array(5)].map((_, i) => (
//                         <span key={i}>
//                           <i className="fa fa-star"></i>
//                         </span>
//                       ))}
//                     </div>
//                   </div>

//                   {/* QUOTE ICON */}
//                   <div className="twm-quote-icon">
//                     <img src="images/quote.png" alt="quote" />
//                   </div>

//                 </div>
//               </SwiperSlide>
//             ))}
//           </Swiper>
//         </div>

//       </div>
//     </div>
//   );
// };

// export default TestimonialSectionabout;













import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";

const testimonials = [
  {
    name: "Mr. Rohit Patil",
    text: "Shivai Travels provided excellent Pune to Mumbai cab service. The driver was polite and the ride was very smooth and comfortable.",
  },
  {
    name: "Miss. Aishwarya Deshmukh",
    text: "We booked an Innova Crysta for a family trip to Lonavala. Great service, clean car, and on-time pickup. Highly recommended!",
  },
  {
    name: "Mr. Sagar Jadhav",
    text: "Best outstation cab service from Pune. Very professional drivers and hassle-free booking experience with Shivai Travels.",
  },
  {
    name: "Miss. Pooja Kulkarni",
    text: "Tempo Traveller was very spacious and perfect for our group tour to Mahabaleshwar. Excellent service and affordable pricing.",
  },
  {
    name: "Mr. Nikhil Shinde",
    text: "Used Shivai Travels for airport pickup and drop. Always on time, clean cars, and very professional service every time.",
  },
];

const TestimonialSectionabout = () => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  return (
    <div className="section-full p-t150 site-bg-white twm-testimonial-section-wrap wow fadeInDown">
      <div className="container">

        <div className="row">
          <div className="col-lg-6 col-md-12">
            <div className="section-head left">
              <div className="twm-sm-title left">Testimonial</div>
              <h2 className="twm-large-title site-text-dark">
                What Our Customers Say
              </h2>
            </div>
          </div>
        </div>

        <div className="section-content position-relative">

          <button ref={prevRef} className="custom-swiper-btn custom-prev">
            ❮
          </button>

          <button ref={nextRef} className="custom-swiper-btn custom-next">
            ❯
          </button>

          <Swiper
            modules={[Autoplay, Navigation]}
            spaceBetween={30}
            slidesPerView={3}
            loop={true}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            onBeforeInit={(swiper) => {
              swiper.params.navigation.prevEl = prevRef.current;
              swiper.params.navigation.nextEl = nextRef.current;
            }}
            navigation={{
              prevEl: prevRef.current,
              nextEl: nextRef.current,
            }}
            breakpoints={{
              0: { slidesPerView: 1 },
              768: { slidesPerView: 2 },
              1200: { slidesPerView: 3 },
            }}
          >
            {testimonials.map((item, index) => (
              <SwiperSlide key={index}>
                <div className="twm-testimonial2">

                  <div className="twm-testimonial-head">
                    <div className="twm-author-detail">
                      <h3 className="twm-title">{item.name}</h3>
                      <div className="twm-position">Customer</div>
                    </div>
                  </div>

                  <div className="twm-testimonial-detail">
                    <p>{item.text}</p>

                    <div className="twm-rating-wrap">
                      {[...Array(5)].map((_, i) => (
                        <span key={i}>
                          <i className="fa fa-star"></i>
                        </span>
                      ))}
                    </div>
                  </div>

                  <div className="twm-quote-icon">
                    <img src="images/quote.png" alt="quote" />
                  </div>

                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  );
};

export default TestimonialSectionabout;

